<template>
    <v-slide-group
        center-active
    >
      <v-slide-item
          v-slot:default="{ active, toggle }"
          v-for="(navigation, index) in navigations"
          :key="index"
      >
        <v-card :class="[index !== 0 && index !== navigations.length-1 ? swipeMenuCardInner : '' ,
                          index === 0 ? swipeMenuCardFirst : '',
                          index === navigations.length-1 ? swipeMenuCardLast : '',
                          swipeMenuCard]"
            :color="active ? 'white' : 'white'"
            height="18vh"
            width="33vw"
            @click="trigger(index)"
            :ripple="false"
        >
          <v-row
              class="fill-height"
              align="center"
              justify="center"
          >
            <v-col cols="12">
              <Component :is="navigation.icon"/>
            </v-col>
            <v-col cols="12" class="pt-0 textSize__14" v-text="navigation.name">
            </v-col>
          </v-row>
        </v-card>
      </v-slide-item>
    </v-slide-group>
</template>

<script>
import {mapActions, mapMutations} from 'vuex'
import generalArticles from "@/assets/navigation/generalArticles";
import searchArticles from "@/assets/navigation/searchArticles";
import notesLarge from "@/assets/navigation/notesLarge";
import myAccount from "@/assets/navigation/myAccount";
import newArticles from "@/assets/navigation/newArticles";
import discountedArticlesIcon from "@/assets/navigation/discountedArticlesIcon.vue";
import router from "@/router";

export default {
  name: "swipeMenu",
  components: {generalArticles, searchArticles, notesLarge, myAccount, newArticles, discountedArticlesIcon},
  data: () => {
    return {
      navigations: [{icon: 'generalArticles', name: 'Artikel durchstöbern'},
                    {icon: 'newArticles', name: 'Neu im Sortiment'},
                    {icon: 'searchArticles', name: 'Artikel suchen oder scannen'},
                    {icon: 'discountedArticlesIcon', name: 'Aktions-Artikel'},
                    {icon: 'notesLarge', name: 'Gemerkte Artikel ansehen'},
                    {icon: 'myAccount', name: 'Mein Konto'},
      ],

      swipeMenuCardFirst: 'swipeMenuCardFirst',
      swipeMenuCardInner: 'swipeMenuCardInner',
      swipeMenuCardLast: 'swipeMenuCardLast',
      swipeMenuCard: 'swipeMenuCard'
    }
  },

  methods: {
    ...mapActions({
      forwardToCategories: 'forwardToCategories',
      forwardToWatchlist: 'forwardToWatchlist'
    }),

    ...mapMutations({
      setBarcodeScannerState: 'setBarcodeScannerState',
      setCurrentCategory: 'setCurrentCategory'
    }),

    trigger(data) {
      if(data === 0) {
        this.setCurrentCategory(null)
        this.forwardToCategories()
      } else if(data === 1) {
        router.push({path: '/shop/newArticles'})
      }
      else if(data === 2) {
        this.setBarcodeScannerState()
      } else if(data === 3) {
        router.push({name: 'DiscountedArticles'})
      } else if(data === 4) {
        this.forwardToWatchlist()
      } else if(data === 5) {
        router.push({name: 'Benutzerprofil'})
      }
    },
  }
}
</script>

<style>
</style>
